import { gql } from "@apollo/client";

export const SELECT_INVITE_FOR_SELECT = gql`
  query GetInvitesForSelect {
    getInvitesForSelect {
      _id
      name
    }
  }
`;

export const SELECT_ALL_NOTIFY = gql`
  query GetAllNotifyForSelect {
    getAllNotifyForSelect {
      _id
      name
      profile
    }
  }
`;

export const INVITE_AS_FOR_SELECT = gql`
  query Query {
    getInviteAsForSelect
  }
`;

export const SELECT_ENROLLMENT_BY_STUDENT = gql`
  query SelectEnrollmentByStudent($studentId: ID, $academicYearId: ID) {
    selectEnrollmentByStudent(
      studentId: $studentId
      academicYearId: $academicYearId
    ) {
      _id
      classId {
        _id
        className
        gradeId {
          _id
          gradeName
        }
      }
    }
  }
`;

export const SELECT_STUDENT = gql`
  query SelectStudents {
    selectStudents {
      _id
      englishName
      profileImg
      firstName
      lastName
    }
  }
`;
export const SELECT_ACADEMIC_YEAR = gql`
  query SelectAcademicYears($status: Boolean) {
    selectAcademicYears(status: $status) {
      _id
      academicYear
      academicYearInKhmer
    }
  }
`;

export const SELECT_GRADE_BY_ACADEMIC = gql`
  query SelectGrade($academicYearId: ID) {
    selectGrade(academicYearId: $academicYearId) {
      _id
      gradeName
    }
  }
`;

export const SELECT_SCHOOL = gql`
  query SelectSchool {
    selectSchool {
      _id
      schoolName
    }
  }
`;

export const SELECT_PROGRAMM = gql`
  query SelectProgram {
    selectProgram {
      _id
      programmName
      programmNameEn
      code
    }
  }
`;
